var map = {
	"./goldcoin/squad-icon-4.png": 86685,
	"./memetown/squad-icon-4.png": 45423,
	"./reflection/squad-icon-4.png": 75002,
	"./tapcoin/squad-icon-4.png": 83051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54673;